import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const FilterNode = ({ id, data }) => {
  const [condition, setCondition] = useState(data?.condition || 'equals');
  const [value, setValue] = useState(data?.value || '');

  const config = {
    title: 'Filter',
    fields: [
      {
        name: 'condition',
        type: 'select',
        label: 'Condition',
        value: condition,
        onChange: (e) => setCondition(e.target.value),
        options: ['equals', 'contains', 'greater_than', 'less_than', 'not_empty'],
      },
      {
        name: 'value',
        type: 'text',
        label: 'Value',
        value: value,
        onChange: (e) => setValue(e.target.value),
        placeholder: 'Comparison value',
      },
    ],
    handles: [
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-input`,
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-true`,
        style: { top: '40%' },
        className: '!bg-green-500',
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-false`,
        style: { top: '60%' },
        className: '!bg-red-500',
      },
    ],
    width: 220,
    height: 140,
  };

  return <BaseNode id={id} data={data} config={config} />;
};